/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

/**
 * Generated class for the StatusIcon component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'status-icon',
  templateUrl: 'status-icon.html'
})
export class StatusIcon {


  icons: Array<string> = [
    'md-radio-button-off',
    'md-radio-button-off',
    'md-arrow-dropright-circle',
    'md-checkmark-circle',
    'md-timer',
    'md-close-circle',
    'md-checkmark-circle',
    'md-ribbon'
  ];

  styles: Array<string> = [
    'off',
    'off',
    'on',
    'complete',
    'hold',
    'cancelled',
    'complete',
    'off'
  ];


  @Input()
  status: number;

  constructor() {
    // console.log('Hello StatusIcon Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/status-icon/status-icon.ts